<template>
  <div class="cdn-breadcrumbs">
    <div
      v-for="(item, index) in items"
      :key="index"
      :class="index === items.length - 1 ? 'breadcreumb-last' : 'breadcreumb-item'"
      @click="() => {item.click && item.click()}"
    >
      <span>{{item.label}}</span>
        <CDNIcon v-if="index !== items.length - 1" name="keyboard_arrow_right" size="22" />
    </div>
    <div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: { type: Array, default: () => [] },
  },
};
</script>
<style lang="scss" scoped>
  .cdn-breadcrumbs {
    display: flex;
    align-items: center;
    .breadcreumb-item {
      display: flex;
      align-items: center;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5A607F;
      letter-spacing: 0;
      cursor: pointer;
      i {
        color: #5A607F;
      }
    }
    .breadcreumb-last {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #1E5EFF;
      letter-spacing: 0;
    }
  }
</style>
